import moment from 'moment';

export default function calculateRemainingDays(date){
  const given = moment(date, 'YYYY-MM-DD'),
    current = moment().startOf('day'),
    days = moment.duration(given.diff(current)).asDays();
  return Math.floor(days);
}
